/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import {FaChevronLeft} from 'react-icons/fa'
import './rightBtn.scss'


export default function RightBtn(props) {
    return (
        <button className="show-all" onClick={props.onClick}>
            <FaChevronLeft />
        </button>
    )
}
